import React from "react";
import ReviewManagementTargets from "../../features/reviewmanagementtargets";
import { ClientReviewManagementFilterSubHeader } from "../../layouts/ClientReviewManagementLayout";

const ReviewManagementTargetsPage = () => 
    <React.Fragment>
        <ClientReviewManagementFilterSubHeader includeCompletedSelect={true}/>
        <section className="px-4 my-3 h-100">
            <ReviewManagementTargets />
        </section>
    </React.Fragment>

export default ReviewManagementTargetsPage;